import { useId } from 'react'
import { usePageDropTarget, useUploadActions } from '../lib/upload-manager.js'

type Props = {
  projectId: string
  projectName: string
}

/**
 * プロジェクト詳細のアップロード欄（ドロップの案内 + ファイル選択）。
 *
 * - この画面を開いている間は、メイン領域のどこに落としてもこのプロジェクトへ入る
 *   （ドロップの受け付けと進捗は upload-manager / 右下の UploadPanel が担う）
 * - 同時 2 件まで FIFO で送信。50MB 以下は単発、超えるとマルチパート
 */
export function FileUpload({ projectId, projectName }: Props) {
  const inputId = useId()
  const { enqueue } = useUploadActions()
  usePageDropTarget({ projectId, projectName })

  return (
    <div className="rounded-lg border-2 border-dashed border-border bg-muted/20 px-6 py-10 text-center">
      <div aria-hidden="true" className="mb-2 select-none text-3xl">
        ⬆
      </div>
      <p className="text-sm text-muted-foreground">
        ファイルをこの画面にドラッグ & ドロップ
        <span className="mx-2 text-muted-foreground/50">·</span>
        <label
          htmlFor={inputId}
          className="cursor-pointer font-medium text-foreground underline decoration-foreground/30 underline-offset-4 hover:decoration-foreground"
        >
          ファイルを選択
        </label>
      </p>
      <p className="editorial-num mt-2 font-mono text-[11px] text-muted-foreground/70">
        ファイルサイズに応じて並列アップロードを自動最適化 · 動画は自動で再生できる形に変換
      </p>
      <input
        id={inputId}
        type="file"
        multiple
        className="sr-only"
        onChange={(e) => {
          if (e.target.files && e.target.files.length > 0) {
            enqueue({ projectId, projectName }, e.target.files)
          }
          // 同じファイルを続けて選んでも change が発火するよう空に戻す
          e.target.value = ''
        }}
      />
    </div>
  )
}
